import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Header from "../components/Header";
import { useState, useEffect } from "react";
import { getDataHelper } from "../requests/PostRequests";
import NavBar from "../components/NavBar";

const Resources = () => {

  const [resources, setResources] = useState([]);

  async function getUserGuides() {
    const onSuccess = (data) => {
      let newResources = [];
      const rows = data.result.rows;
      const length = rows.length;

      for (let i = 0; i < length; i++) {
        let userGuideResources = [];
        const resourceLength = rows[i].user_guide_resources.length;
        for (let j = 0; j < resourceLength; j++) {
          userGuideResources.push({
            id: rows[i].user_guide_resources[j].id,
            name: rows[i].user_guide_resources[j].name,
            url: rows[i].user_guide_resources[j].url,
          });
        }

        newResources.push({
          id: parseInt(rows[i].id),
          title: rows[i].title,
          image_url: rows[i].image_url,
          description: rows[i].description,
          user_guide_resources: userGuideResources,
        });
      }

      setResources(newResources.sort((a, b) => a.id - b.id));
    };

    await getDataHelper("/v1/user-guides", (title, content, type) => console.log(`${title}, ${content}, ${type}`), onSuccess);
  }

  useEffect(() => {
    async function fetchData() {
      await getUserGuides();
    }

    fetchData();
  }, []);

  return (
    <div className="container-content-fixed">
      <NavBar />
      <Header title="Resources" />
      <Row xs={1} md={2} lg={3} className="g-3">
        {resources.map(function (item, idx) {
          return (
            <Col key={idx + '_col'}>
              <Card
                key={idx + '_card'}
                border="muted"
                style={{
                  height: "30rem",
                  margin: "10px",
                  display: "flex",
                }}
              >
                <Card.Img
                  variant="top"
                  src={item.image_url}
                  alt="Card image"
                  style={{ height: "15vw" }}
                />
                <Card.Body>
                  <Card.Title style={{ marginBottom: "10px" }}>
                    {item.title}
                  </Card.Title>
                  <Card.Text>{item.description}</Card.Text>
                  <ul>
                    {item.user_guide_resources.map(function (item, _) {
                      return (
                        <li key={item.id + '_resource'}>
                          <a href={item.url}>{item.name}</a>
                        </li>
                      );
                    })}
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default Resources;
